import React, { PropTypes } from 'react';
import { canUseDOM } from 'react/lib/ExecutionEnvironment';
import PureComponent from 'components/PureComponent';
import setViewport from 'components/setViewport';
import assign from 'object.assign';
import loadImages from 'utils/loadImages';
import checkMobile from 'utils/checkMobile';

class Page extends PureComponent {
  static propTypes = {
    backgroundAspectRatio: PropTypes.number.isRequired
  };

  static defaultProps = {
    backgroundAspectRatio: 1.5
  };

  static contextTypes = {
    deviceType: PropTypes.string
  };

  constructor() {
    super();
    this.state = { showBackground: false };
  }

  componentWillMount() {
    const backgroundImage = (this.props.style || {}).backgroundImage;

    if (backgroundImage && canUseDOM) {
      loadImages([backgroundImage.replace(/^url\((.*)\)$/, '$1')]).then(() =>
        this.setState({ showBackground: true })
      );
    }
  }

  render() {
    require('./Page.styl');
    const { deviceType } = this.context;
    const isMobile = checkMobile(deviceType, this.props.viewport);
    const backgroundImage = (this.props.style || {}).backgroundImage;
    const style = assign({}, this.props.style || {}, { backgroundImage: '' });

    return (
      <div
        {...this.props}
        className={`Page Page--${isMobile ? 'mobile' : 'desktop'} ${
          this.props.className
        }`}
        style={style}
      >
        {this.props.children}
        <div
          className="Page__background"
          style={{
            backgroundImage,
            opacity: this.state.showBackground ? 1 : 0
          }}
        />
      </div>
    );
  }
}

export default setViewport(Page);



// WEBPACK FOOTER //
// ./src/components/Page/Page.js